import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import checkoutClient from '../logic/checkout';
import { useCart } from '../utils/contexts/cart-context';
import { IonPage, IonContent, IonSpinner } from '@ionic/react';
import { useTracker } from '../utils/contexts/tracker-context';
import { useRestaurant } from '../utils/contexts/restaurant-context';
import BilldReceiptButton from '../components/BilldReceiptButton';
import stripeClient from '../logic/stripe';

export default function OrderSuccessPage() {
    const { trackDataFn } = useTracker();

    const { type, id } = useParams();

    const { t } = useTranslation();

    const { setPayed } = useCart();

    const { restaurant } = useRestaurant();

    const [orderId, setOrderId] = React.useState(undefined);
    const [preparingReceipt, setPreparingReceipt] = React.useState(false);

    React.useLayoutEffect(() => {
        async function storagePaypal() {
            // let urlParams = new URLSearchParams(window.location.search);
            let storage = window.localStorage.getItem("__mycontactlessmenu_payload__");
            let coupon = window.sessionStorage.getItem("coupon");
            if (storage) {
                let payload = JSON.parse(storage);
                payload.order.payed = true;
                payload.transaction.id = /*urlParams.get("transactionid")*/ "noid";
                payload.transaction.provider = "paypal";

                if (coupon) {
                    coupon = JSON.parse(coupon);
                    if (String(coupon.restaurantAccepted) === String(restaurant.id)) {
                        payload.order.coupon = coupon;
                    }
                } else { payload.order.coupon = {}; }

                let data = checkoutClient.build(payload.restaurant, payload.order, payload.transaction);

                await trackDataFn(restaurant.id, restaurant.token, "sendorder", data, restaurant.has_orders);
                await checkoutClient.doPost(data, restaurant.has_billd);
            }
        }
        async function storageSumup() {
            // let urlParams = new URLSearchParams(window.location.search);
            let storage = window.localStorage.getItem("__mycontactlessmenu_payload__");
            let coupon = window.sessionStorage.getItem("coupon");
            if (storage) {
                let payload = JSON.parse(storage);
                payload.order.payed = true;
                payload.transaction.id = /*urlParams.get("transactionid")*/ "noid";
                payload.transaction.provider = "sumup";

                if (coupon) {
                    coupon = JSON.parse(coupon);
                    if (String(coupon.restaurantAccepted) === String(restaurant.id)) {
                        payload.order.coupon = coupon;
                    }
                } else { payload.order.coupon = {}; }

                let data = checkoutClient.build(payload.restaurant, payload.order, payload.transaction);

                await trackDataFn(restaurant.id, restaurant.token, "sendorder", data, restaurant.has_orders);
                await checkoutClient.doPost(data, restaurant.has_billd);
            }
        }
        async function storageCash() {
            let storage = window.localStorage.getItem("__mycontactlessmenu_payload__");
            let coupon = window.sessionStorage.getItem("coupon");
            if (storage) {
                let payload = JSON.parse(storage);

                if (coupon) {
                    coupon = JSON.parse(coupon);
                    if (String(coupon.restaurantAccepted) === String(restaurant.id)) {
                        payload.order.coupon = coupon;
                    }
                } else { payload.order.coupon = {}; }

                let data = checkoutClient.build(payload.restaurant, payload.order, payload.transaction);

                await trackDataFn(restaurant.id, restaurant.token, "sendorder", data, restaurant.has_orders);
                // client.doSendMessage(payload);
                await checkoutClient.doPost(data, restaurant.has_billd);
            }
        }
        async function storageStripe() {
            let urlParams = new URLSearchParams(window.location.search);
            let storage = window.localStorage.getItem("__mycontactlessmenu_payload__");
            let coupon = window.sessionStorage.getItem("coupon");
            if (storage) {
                setPreparingReceipt(true);
                let payload = JSON.parse(storage);
                payload.order.payed = true;
                payload.transaction.id = urlParams.get("transactionid");
                payload.transaction.provider = "stripe";

                if (coupon) {
                    coupon = JSON.parse(coupon);
                    if (String(coupon.restaurantAccepted) === String(restaurant.id)) {
                        payload.order.coupon = coupon;
                    }
                } else { payload.order.coupon = {}; }

                let data = checkoutClient.build(payload.restaurant, payload.order, payload.transaction);

                await trackDataFn(restaurant.id, restaurant.token, "sendorder", data, restaurant.has_orders);

                var sripePayload = {
                    type: payload.order.type,
                    risId: payload.restaurant.id,
                    stripePaymentId: payload.transaction.id,
                    orderId: data.order.id,
                };

                await stripeClient.doPostTransaction(sripePayload);
                await checkoutClient.doPost(data, restaurant.has_billd);
                // Billd knows the order only once doPost has sent it: before, /preview is a 404.
                setOrderId(data.order.id);
            }
        }
        async function sendToDashboard() {
            let urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has("provider")) {
                let provider = urlParams.get("provider");

                if ("paypal" === provider) {
                    setPayed(true);
                    storagePaypal();
                }
                if ("cash" === provider) {
                    storageCash();
                }
                if ("sumup" === provider) {
                    setPayed(true);
                    storageSumup();
                }
                if ("stripe" === provider) {
                    setPayed(true);
                    storageStripe();
                }
            }
            window.localStorage.removeItem("__mycontactlessmenu_payload__");
            let coupon = window.sessionStorage.getItem("coupon");
            if (coupon) {
                window.sessionStorage.removeItem("coupon");
            }
        }

        sendToDashboard();
    }, [restaurant.has_orders, restaurant.id, restaurant.token, setPayed, trackDataFn]);

    return (
        <IonPage>
            <IonContent>
                <section id="success-page" className="relative pt-8 pb-32 font-sans text-center">
                    <div className="px-8">
                        {String(restaurant.id) === "9288" ?
                            <p>{t("ordersuccesspage.p_1")}</p> :
                            restaurant.has_pk_sms ?
                                <div>
                                    <div className="bg-[#F6BE01]">
                                        <h2 className="p-8 text-3xl">{t("ordersuccesspage.h2_1")}</h2>
                                    </div>
                                    <div className="m-8">
                                        <p className="font-bold">{t("ordersuccesspage.p_2")}</p>
                                        <p>{t("ordersuccesspage.p_3")}</p>
                                    </div>
                                </div> :
                                <div>
                                    <h2 className="font-bold text-4xl">{t("ordersuccesspage.h2_2")}</h2>
                                    <p className="mt-8">{t("ordersuccesspage.p_4")}</p>
                                </div>}
                    </div>
                    <img src="/assets/images/checkout_success.png" className="w-1/2 m-auto pt-12" alt="checkout success" />

                    <div className="fixed bottom-0 w-full flex flex-col justify-center mt-4 px-4 py-6 bg-white">
                        {(restaurant.has_billd && (orderId || preparingReceipt)) && <BilldReceiptButton orderId={orderId}></BilldReceiptButton>}
                        <a href={`/${type}/q/${id}/menu`} className="block py-2 rounded-full bg-mycia-green">{t("successpage.button_1")}</a>
                    </div>
                </section>
            </IonContent>
        </IonPage>
    );
}
